// GENERATED by apps/bl/scripts/generate-authored-attach-field-registry.ts.
// Do not edit by hand. The backend writer enums are the source of truth.

import { PillarCode } from '../../session/orchestration/tool-protocol/follow-up-refs.js';

/** Exact field vocabulary accepted for every authored string-valued shape. */
export const AUTHORED_ATTACH_FIELD_KEYS = {
  [PillarCode.Academic]: [
    "authors",
    "published",
    "study type",
    "abstract",
    "extract",
    "identifiers",
    "page",
    "pdf",
    "retracted",
    "license",
    "funding",
    "references",
    "open access",
  ],
  [PillarCode.Answer]: [
    "link",
    "publisher",
  ],
  [PillarCode.Apps]: [
    "price",
    "category",
    "age rating",
    "updated",
    "bundle id",
    "package",
    "link",
  ],
  [PillarCode.Books]: [
    "subjects",
    "people",
    "places",
    "periods",
    "about",
    "life",
    "bio",
    "other registries",
    "publishing history",
    "open library",
    "page",
  ],
  [PillarCode.ClassicTexts]: [
    "gutenberg",
    "about",
    "reading ease",
    "subjects",
    "language",
    "rights",
    "size",
    "headings",
    "other editions",
    "wikipedia",
    "continue at",
    "page",
  ],
  [PillarCode.Concerts]: [
    "when",
    "venue",
    "area",
    "what",
  ],
  [PillarCode.Finance]: [
    "price",
    "session",
    "previous close",
    "volume",
    "bid ask",
    "price history",
    "stat",
    "resolved",
    "note",
    "source",
    "published",
    "period ended",
    "items",
    "accession",
    "symbol",
    "ticker",
    "exchange",
    "industry",
    "incorporated in",
    "filer category",
    "fiscal year ends",
    "address",
    "phone",
    "chief executive",
    "founded",
    "employees",
    "website",
    "about",
    "formerly",
    "shares outstanding",
    "cik",
    "lei",
    "figi",
    "ein",
    "period",
    "link",
  ],
  [PillarCode.Github]: [
    "about",
    "topics",
    "homepage",
    "link",
    "repository",
    "raw file",
    "matched code",
    "name",
    "company",
    "location",
  ],
  [PillarCode.HistoricalDocuments]: [
    "match",
    "author",
    "year",
    "edition",
    "size",
    "parts",
    "rights",
    "transcription",
    "wikidata",
    "in",
    "continue at",
    "page",
  ],
  [PillarCode.Jobs]: [
    "where",
    "posted",
    "pay",
    "employer rating",
    "type",
    "skills",
    "experience",
    "benefits",
    "industry",
    "sections",
    "about",
    "source",
    "apply",
  ],
  [PillarCode.Knowledge]: [
    "about",
    "resolved from",
    "disambiguation",
    "page",
    "wikidata",
    "also known as",
    "founded",
    "websites",
    "headquarters",
    "industry",
    "country",
    "candidate ids",
  ],
  [PillarCode.MediaVisual]: [
    "source",
    "channel",
    "size",
    "length",
    "posted",
    "description",
    "image",
    "page",
  ],
  [PillarCode.Music]: [
    "artist",
    "album",
    "also on",
    "released",
    "length",
    "isrc",
    "popularity",
    "tracks",
    "genre",
    "lyrics",
    "ordering",
    "top track",
    "apple music",
    "deezer",
    "spotify",
    "youtube",
    "link",
  ],
  [PillarCode.News]: [
    "link",
    "publisher",
    "published",
    "snippet",
  ],
  [PillarCode.Patents]: [
    "publication number",
    "dates",
    "abstract",
    "in force",
    "page",
    "pdf",
  ],
  [PillarCode.Places]: [
    "where",
    "what",
    "price",
    "phone",
    "site",
    "about",
    "review",
    "opening hours",
    "wheelchair access",
    "osm",
  ],
  [PillarCode.Products]: [
    "price",
    "rating",
    "ratings",
    "seller",
    "condition",
    "bought in the past month",
    "demand",
    "unit price",
    "model",
    "brand",
    "other offers",
    "duplicates dropped",
    "asin",
    "product id",
    "item id",
    "sku",
    "link",
  ],
  [PillarCode.RealEstate]: [
    "price",
    "sold",
    "size",
    "type",
    "listed",
    "status",
    "zillow estimate",
    "area scores",
    "listing id",
    "link",
  ],
  [PillarCode.Scriptures]: [
    "match",
    "original",
    "translation",
    "id",
    "attribution",
    "rights",
    "page",
  ],
  [PillarCode.Social]: [
    "posted",
    "text",
    "engagement",
    "context",
    "comment",
    "name",
    "account",
    "bio",
    "counts",
    "followers",
    "flags",
    "since",
    "id",
    "link",
    "note",
  ],
  [PillarCode.Trends]: [
    "interest",
    "share",
    "growth",
    "link",
  ],
  [PillarCode.Youtube]: [
    "channel",
    "posted",
    "length",
    "engagement",
    "video id",
    "captions",
    "description",
    "transcript",
    "comments",
    "handle",
    "country",
    "audience",
    "since",
    "link",
  ],
} as const;

/** The shape discriminator printed for each authored pillar. */
export const AUTHORED_ATTACH_SHAPE_BY_PILLAR = {
  [PillarCode.Academic]: "academic",
  [PillarCode.Answer]: "answer",
  [PillarCode.Apps]: "apps",
  [PillarCode.Books]: "books",
  [PillarCode.ClassicTexts]: "classic-texts",
  [PillarCode.Concerts]: "concerts",
  [PillarCode.Finance]: "finance",
  [PillarCode.Github]: "github",
  [PillarCode.HistoricalDocuments]: "historical-documents",
  [PillarCode.Jobs]: "jobs",
  [PillarCode.Knowledge]: "knowledge",
  [PillarCode.MediaVisual]: "media-visual",
  [PillarCode.Music]: "music",
  [PillarCode.News]: "news",
  [PillarCode.Patents]: "patents",
  [PillarCode.Places]: "places",
  [PillarCode.Products]: "products",
  [PillarCode.RealEstate]: "real-estate",
  [PillarCode.Scriptures]: "scriptures",
  [PillarCode.Social]: "social",
  [PillarCode.Trends]: "trends",
  [PillarCode.Youtube]: "youtube",
} as const;

export type AuthoredAttachPillar = keyof typeof AUTHORED_ATTACH_FIELD_KEYS;

export type AuthoredAttachShape =
  (typeof AUTHORED_ATTACH_SHAPE_BY_PILLAR)[AuthoredAttachPillar];

export type AuthoredAttachFieldKey<P extends AuthoredAttachPillar> =
  (typeof AUTHORED_ATTACH_FIELD_KEYS)[P][number];
